import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { palette, radius } from './designTokens';

const EmptyState = ({ icon, title, description, action, iconBg, iconColor }) => {
  return (
    <Box
      sx={{
        py: 6, px: 3,
        textAlign: 'center',
        borderRadius: `${radius.md}px`,
        border: `2px dashed ${palette.line}`,
        bgcolor: palette.surfaceAlt,
      }}
    >
      <Stack alignItems="center" spacing={1.25}>
        {icon && (
          <Box
            sx={{
              width: 64, height: 64,
              borderRadius: '50%',
              bgcolor: iconBg ?? palette.brandSoft,
              color: iconColor ?? palette.brand,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        )}
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: palette.ink }}>
          {title}
        </Typography>
        {description && (
          <Typography sx={{ fontSize: 13, color: palette.muted, maxWidth: 420 }}>
            {description}
          </Typography>
        )}
        {action && <Box sx={{ mt: 1 }}>{action}</Box>}
      </Stack>
    </Box>
  );
};

export default EmptyState;
